import * as React from "react"
import * as ReactDom from "react-dom"

import View from "../views/instructions"

export const page = async () => {
	const res = await fetch('/aguila/loyalty/validate-game')
  const data = await res.json()

  if (data.response === 1) {
    ReactDom.render(<View /> , document.getElementById('app'))
  } else {
    location.href = '/estadio-aguila/limite-partidas'
  }
}